import { FC } from 'react';
import { useSelector } from 'react-redux';

import {
  Tooltip,
  TooltipProps,
} from '@beeline/design-system-react/extracted-styles';

import { getAgentState } from 'src/store/agent/selectors';

export const TooltipWrapper: FC<TooltipProps> = ({
  disableHover,
  children,
  ...rest
}) => {
  const { touch } = useSelector(getAgentState);

  return (
    <Tooltip {...rest} disableHover={disableHover || touch}>
      {children}
    </Tooltip>
  );
};
